export const remind = {
  driverLicenseExpirationRemind: "驾照有效期提醒",
  vehicleCheckExpirationRemind: "车检有效期提醒",
  maintenanceExpireRemind: "保养到期提醒",
  maintenanceRepairRemind: "维保单提醒",
  remindTimeInAdvance: "有效期小于（天）",
  dueTimeInAdvance: "到期日小于（天）",
  addRemind: "申请提醒（新建、补充材料）",
  approvalRemind: "审批结果提醒",
  cancelRemind: "撤销提醒（保养、维修撤销)",
  closeRemind: "结案提醒（保养、维修完成）",
  reminds: "提醒",
  driverLicenseExpiration: "驾照有效期",
  vehicleCheckExpiration: "车检有效期",
  repairApply: "维修申请",
  repairApproval: "维修审批",
  repairClose: "维修结案",
  repairCancel: "维修撤销",
  maintenanceApply: "保养申请",
  maintenanceApproval: "保养审批",
  maintenanceClose: "保养结案",
  maintenanceCancel: "保养撤销",
  maintenanceRemind: "保养到期",
  time: "时间",
  events: "事件",
  details: "详情",
  driverLicenseExpirationTips: "{0}的驾照将于{1}到期",
  vehicleCheckExpirationTips: "设备{0}的车检有效期将于{1}到期",
  repairApplyTips: "设备编号{0}的申请维修，维修单号{1}",
  repairApprovalTips: "设备编号{0}的维修单{1}（{2}）",
  repairCloseTips: "设备编号{0}的维修单{1}已结案",
  repairCancelTips: "设备编号{0}的维修单{1}已撤销",
  maintenanceApplyTips: "设备编号{0}申请保养，保养单号{1}",
  maintenanceApprovalTips: "设备编号{0}的保养单{1}（{2}）",
  maintenanceCloseTips: "设备编号{0}的保养单{1}已结案",
  maintenanceCancelTips: "设备编号{0}的保养单{1}已撤销",
  maintenanceRemindTips: "设备{0}下一次保养日期为{1}",
  noLongerRemind: "不再提醒",
  receiveRemind: "接收提醒",
  confirmNoLongerRemind: "所选记录将不再提醒。确定要继续吗？",
  repairDetailTips: "设备编号【{0}】的维修单号【{1}】{2}",
  maintDetailTips: "设备编号【{0}】的保养单号【{1}】{2}",
  doneStatus: "已结案",
  applyStatus: "审批中",
  approvalStatus: "维保中",
  cancelStatus: "已撤销",
  modifyStatus: "待补充",
  rejectStatus: "已驳回",
  criticalItemFailed: "设备编号【{0}】点检关键项未通过",
};
